module.exports = __webpack_public_path__ + "img/scale_primary.e477c59b.svg";